import * as R from "ramda";

export const getType = R.prop("field_type");
export const getInstructions = R.pipe(R.path(["ui", "form_input"]), R.pick(["text", "title"]));
export const getTermsAndConditions = R.prop("terms_and_conditions_markdown");
export const isList = R.prop("is_list");
export const isUseCodeCondition = R.prop("use_code_condition");
export const isCalculated = R.prop("calculated");
export const findFieldByType = (fields, type) => R.find((f) => R.equals(type, getType(f)), fields);

export const getFieldEnumByCode = R.curry((code, field) =>
  R.compose(
    R.find((e) => R.propEq(code, "code", e)),
    R.propOr([], "enum"),
  )(field),
);

export const getEnumLabelByCode = (field, code) =>
  R.compose(R.prop("label"), getFieldEnumByCode(code))(field);
